<template>
  <div class="body">

    <flipbook class="flipbook" :pages="imgs" v-slot="flipbook" :startPage="pageNum" style="text-align: center">
      <div class="action-bar">
        <left-icon
            class="btn left"
            :class="{ disabled: !flipbook.canFlipLeft }"
            @click="flipbook.flipLeft"
        />
        <plus-icon
            class="btn plus"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
        />
        <span class="page-num">
          第 {{ flipbook.page }} 页 , 总{{ flipbook.numPages }}页
        </span>
        <minus-icon
            class="btn minus"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
        />
        <right-icon
            class="btn right"
            :class="{ disabled: !flipbook.canFlipRight }"
            @click="flipbook.flipRight"
        />
      </div>
    </flipbook>
  </div>

</template>

<script>
  import Flipbook from 'flipbook-vue'
  import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
  import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
  import PlusIcon from 'vue-material-design-icons/PlusCircle'
  import MinusIcon from 'vue-material-design-icons/MinusCircle'
  export default {
    components: {Flipbook,LeftIcon,RightIcon,PlusIcon,MinusIcon },
    name: "index",
    data(){
      return {
        turnWidth:0,
        turnHeight:0,
        imgs:[],
        pageNum:1
      }
    },
    mounted() {
      const num = this.$route.query.pageNum
      if(num){
        this.pageNum = num
      }
      const str = this.$route.query.list
      // const str = "/2020/12/15/788466013905784832.PNG,/2020/12/15/788466014375546880.PNG,/2020/12/15/788466014895640576.PNG,/2020/12/15/788466015348625408.PNG,/2020/12/15/788466015818387456.PNG,/2020/12/15/788466016296538112.PNG,/2020/12/15/788466016778883072.PNG,/2020/12/15/788466017240256512.PNG,/2020/12/15/788466017705824256.PNG,/2020/12/15/788466018158809088.PNG,/2020/12/15/788466019349991424.PNG,/2020/12/15/788466019794587648.PNG,/2020/12/15/788466020260155392.PNG,/2020/12/15/788466020742500352.PNG,/2020/12/15/788466022747377664.PNG,/2020/12/15/788466023212945408.PNG,/2020/12/15/788466023682707456.PNG,/2020/12/15/788466025670807552.PNG,/2020/12/15/788466026140569600.PNG,/2020/12/15/788466026606137344.PNG,/2020/12/15/788466028627791872.PNG,/2020/12/15/788466029084971008.PNG,/2020/12/15/788466029546344448.PNG,/2020/12/15/788466031567998976.PNG,/2020/12/15/788466032046149632.PNG,/2020/12/15/788466032507523072.PNG,/2020/12/15/788466034394959872.PNG,/2020/12/15/788466034852139008.PNG,/2020/12/15/788466035313512448.PNG,/2020/12/15/788466037221920768.PNG,/2020/12/15/788466037679099904.PNG,/2020/12/15/788466038127890432.PNG,/2020/12/15/788466038585069568.PNG,/2020/12/15/788466040581558272.PNG,/2020/12/15/788466041051320320.PNG,/2020/12/15/788466041512693760.PNG,/2020/12/15/788466043517571072.PNG,/2020/12/15/788466043999916032.PNG,/2020/12/15/788466044444512256.PNG,/2020/12/15/788466044901691392.PNG,/2020/12/15/788466046982066176.PNG,/2020/12/15/788466047426662400.PNG,/2020/12/15/788466047892230144.PNG,/2020/12/15/788466049909690368.PNG,/2020/12/15/788466050387841024.PNG,/2020/12/15/788466050912129024.PNG,/2020/12/15/788466052862480384.PNG,/2020/12/15/788466053319659520.PNG,/2020/12/15/788466053772644352.PNG,/2020/12/15/788466054431150080.PNG,/2020/12/15/788466056394084352.PNG,/2020/12/15/788466056868040704.PNG,/2020/12/15/788466057333608448.PNG,/2020/12/15/788466057790787584.PNG,/2020/12/15/788466059825025024.PNG,/2020/12/15/788466060282204160.PNG,/2020/12/15/788466060718411776.PNG,/2020/12/15/788466062660374528.PNG,/2020/12/15/788466063100776448.PNG,/2020/12/15/788466063486652416.PNG,/2020/12/15/788466065525084160.PNG,/2020/12/15/788466065965486080.PNG,/2020/12/15/788466066435248128.PNG,/2020/12/15/788466068393988096.PNG,/2020/12/15/788466068855361536.PNG,/2020/12/15/788466069320929280.PNG,/2020/12/15/788466071254503424.PNG,/2020/12/15/788466071803957248.PNG,/2020/12/15/788466072265330688.PNG,/2020/12/15/788466072764452864.PNG,/2020/12/15/788466074790301696.PNG,/2020/12/15/788466075239092224.PNG,/2020/12/15/788466075675299840.PNG,/2020/12/15/788466077650817024.PNG,/2020/12/15/788466078107996160.PNG,/2020/12/15/788466078565175296.PNG,/2020/12/15/788466080490360832.PNG,/2020/12/15/788466080972705792.PNG,/2020/12/15/788466081421496320.PNG,/2020/12/15/788466083367653376.PNG,/2020/12/15/788466084567224320.PNG,/2020/12/15/788466085016014848.PNG,/2020/12/15/788466085489971200.PNG,/2020/12/15/788466085930373120.PNG,/2020/12/15/788466087964610560.PNG,/2020/12/15/788466088396623872.PNG,/2020/12/15/788466089080295424.PNG,/2020/12/15/788466089520697344.PNG,/2020/12/15/788466089986265088.PNG,/2020/12/15/788466091932422144.PNG"
      let arr = str.split(",")
      arr.forEach(item =>{
        this.imgs.push(this.$FILE_PATH + item)
      })
    },
    methods:{

    }
  }
</script>

<style scoped>
  .body{
    width:100vw;
    height:100vh;
    background-image: url("https://file.kinfriend.com/app/pedigree-bg.png");
    background-color: #002121;
    background-repeat:no-repeat;
  }
  .action-bar {
    width: 100%;
    height: 30px;
    padding-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .action-bar .btn {
    color: white;
  }

  .action-bar .btn svg {
    bottom: 0;
  }

  .action-bar .btn:not(:first-child) {
    margin-left: 10px;
  }

  .has-mouse .action-bar .btn:hover {
    color: white;
    filter: drop-shadow(1px 1px 5px #000);
    cursor: pointer;
  }

  .action-bar .btn:active {
    filter: none !important;
  }

  .action-bar .btn.disabled {
    color: #666;
    pointer-events: none;
  }

  .action-bar .page-num {
    font-size: 30px;
    margin-left: 10px;
  }

  .flipbook {
    width: 100vw;
    height: calc(100vh - 50px - 40px);
  }

  .flipbook .bounding-box {
    box-shadow: 0 0 20px #000;
  }

</style>
